import { MessageSquare } from "lucide-react";

const EmptyChatState = () => (
  <div className="flex h-full select-none flex-col items-center justify-center gap-3 text-gray-400">
    <MessageSquare className="size-12 opacity-40" />
    <p className="text-sm font-medium text-gray-500">No messages yet</p>
    <p className="px-8 text-center text-xs">
      Send your first message to start the conversation
    </p>
  </div>
);

export default EmptyChatState;
